import { FC } from 'react';
import { FeedController } from './feed-controller';
import { SplitContactSuggestionCard } from './contact-suggestion-card/split-contact-suggestion-card';
import { useSuggestionsFeed } from '../hooks/use-suggestions-feed';
import { Link, useSearchParams } from 'react-router-dom';
import { paths } from '../../../../../routes/paths';
import { LoadingNetworkAnimation } from './loading-network-animation';
import { useState, useEffect } from 'react';
import { ContactSuggestionCard } from './contact-suggestion-card/contact-suggestion-card';
import { Button } from '@shadcn/ui/components/ui/button';

export const ContactSuggestionsFeed: FC = () => {
    const { contactSuggestions } = useSuggestionsFeed();
    const [searchParams] = useSearchParams();
    const [isInsideNetwork, setIsInsideNetwork] = useState(searchParams.get('insideNetwork') === 'true');

    useEffect(() => {
        setIsInsideNetwork(searchParams.get('insideNetwork') === 'true');
    }, [searchParams]);

    if (contactSuggestions?.length) {
        return (
            <div className="flex flex-row items-center h-full w-full gap-4">
                <FeedController className="hidden md:flex" />
                <div className="flex flex-col items-center justify-center w-full h-full">
                    {isInsideNetwork ? <ContactSuggestionCard /> : <SplitContactSuggestionCard />}
                </div>
            </div>
        );
    } else {
        return (
            <div className="flex flex-col items-center justify-center h-full w-full gap-8">
                <div className="flex flex-col items-center justify-center space-y-8 p-12 max-w-5xl mx-auto rounded-xl bg-background/60 backdrop-blur-xs shadow-xs">
                    <div className="flex flex-col items-center justify-center space-y-4">
                        <div className="w-72 h-72 flex items-center justify-center">
                            <LoadingNetworkAnimation />
                        </div>
                        <h3 className="text-4xl text-center font-semibold text-text-primary">
                            Add Contacts to playbooks, we'll find more like them
                        </h3>
                        <div className="space-y-2 max-w-2xl">
                            <p className="text-center text-lg text-text-secondary leading-relaxed">
                                We'll find more people in your network similar to the contacts in your playbooks and
                                update suggestions daily.
                            </p>
                        </div>
                    </div>
                    <div className="flex flex-col items-center justify-center space-y-4">
                        <Button variant="outline" size="lg" asChild>
                            <Link to={paths.NEW.CONTACTS}>Go to Contacts</Link>
                        </Button>
                    </div>
                </div>
            </div>
        );
    }
};
